import { useLinks } from 'core/components/linksContext';
import { IProductFormTypeFull } from 'core/const';
import { icon, row } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { IStyledComponentProps, ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { styles as previewStyles } from 'site/components/contacts/ContactsPreview';
import CreditCardIcon from '../../../svg/credit-card.svg';
import LaptopIcon from '../../../svg/laptop.svg';
import QuestionIcon from '../../../svg/question-mark.svg';
import VideoIcon from '../../../svg/video.svg';

type IProductFaqSectionProps = {
    formTypes: IProductFormTypeFull[];
    ContactsPreview?: React.ComponentType<IStyledComponentProps<typeof previewStyles>>;
} & WithStyles<typeof styles>;

const ProductFaqSection: React.FC<IProductFaqSectionProps> = ({ classes, formTypes, ContactsPreview }) => {
    const links = useLinks();

    return (
        <div className={classes.wrapper}>
            <div className={classes.list}>
                {(formTypes.includes('WEBINAR') || formTypes.includes('SEMINAR')) && (
                    <div className={classes.item}>
                        <LaptopIcon className={classes.icon} />
                        <p className={classes.title}>Вебинар</p>
                        <p>
                            Вебинар &mdash; это онлайн-занятие. Все доступы к вебинару находятся в личном кабинете и
                            дублируются ссылкой на почту
                        </p>
                    </div>
                )}
                {(formTypes.includes('EVENT_RECORD') || formTypes.includes('VIDEO_COURSE')) && (
                    <div className={classes.item}>
                        <VideoIcon className={classes.icon} />
                        <p className={classes.title}>Видеозапись</p>
                        <p>
                            Это запись уже прошедшего курса. Все доступы к записи будут находиться в личном кабинете и
                            дублироваться ссылкой на почту
                        </p>
                    </div>
                )}
                <div className={classes.item}>
                    <CreditCardIcon className={classes.icon} />
                    <p className={classes.title}>Оплата</p>
                    <p>
                        На бесплатное занятие можно просто записаться. Платные занятия можно оплатить удобным способом:
                        карта, QIWI, Яндекс.Деньги и другими
                    </p>
                </div>
                <div className={classes.item}>
                    <QuestionIcon className={classes.icon} />
                    {ContactsPreview && (
                        <>
                            <p className={classes.title}>По всем вопросам</p>
                            <ContactsPreview
                                classes={{
                                    root: classes.contacts,
                                }}
                            />
                        </>
                    )}
                    <div>
                        <links.faq.Link to={links.faq.url()} className={classes.title}>
                            Ответы на часто задаваемые вопросы
                        </links.faq.Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        wrapper: {
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: 1170,
            padding: '30px 0 15px 0',

            [theme.breakpoints.down('xs')]: {
                padding: 20,
            },
        },
        list: {
            ...row(),

            [theme.breakpoints.down('sm')]: {
                justifyContent: 'space-around',
            },

            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                padding: '0 15px',
                maxWidth: 320,
                marginLeft: 'auto',
                marginRight: 'auto',
            },
        },
        item: {
            flexBasis: 'calc(25% - 40px)',
            paddingLeft: 20,
            paddingRight: 20,

            [theme.breakpoints.down('sm')]: {
                flexBasis: 40 + '%',
            },

            [theme.breakpoints.down('xs')]: {
                textAlign: 'center',
                maxWidth: 'unset',
                flexBasis: 'unset',
            },
        },
        icon: {
            flex: 'none',
            ...icon,
            marginBottom: 0.75 + 'rem',
            fill: theme.colors.black,
            width: 75,
            height: 55,
        },
        title: {
            fontWeight: 'bold',
            marginBottom: 0.75 + 'rem',
        },
        contacts: {
            marginBottom: 2 + 'rem',

            '& svg': {
                fill: theme.colors.linkOld,
            },
        },
    });

export default injectSheet(styles, 'ProductFaqSection')(ProductFaqSection);
